import {
  SmartComponentPropertyDetails,
  SmartComponentSummaryData,
} from "../smart-components/smart-component-property-details";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";
import { AddressDetails } from "../smart-components/smart-component-property";
import { ComponentAdapterCounterParent } from "./component-adapter-counter-parent";

/**
 * Component adapter for counter gas
 */
export class ComponentAdapterCounterGas
  extends ComponentAdapterCounterParent
  implements IComponentLoader
{
  private _volume: AddressDetails = null;

  /**
   * Get address about volume skill
   */
  get Volume(): AddressDetails {
    return this._volume;
  }

  constructor() {
    super();
  }

  public fillProperty(
    listSmartComponentSkills: Array<SmartComponentPropertyDetails>,
    data: SmartComponentSummaryData
  ): void {
    this._summary = data.summary;
    this._idSmartComponentKind = data.idSmartComponentKind;
    this._idEnvironment = data.idEnvironment;
    this._name =
      listSmartComponentSkills.find(
        (titleSkill) => titleSkill.titleSkill === SkillNameList.COUNTER_GAS_NAME
      )?.value || "";
    this._description =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_GAS_DESCRIPTION
      )?.value || "";
    this._volume =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_GAS_VOLUME
      )?.address || null;

    this.fillMissingProperty();
    this.fillAddressState();
  }

  public fillMissingProperty(): void {}

  public fillAddressState(): void {}
}
